<template>
    <div class="row">
        <div :class="vertical ? 'col-12' : 'col-6'" id="photo-widget">
            <img :src="imageUrl" class="img-fluid" alt="Your photo" />
            <image-cropper
                v-model="cropperIsActive"
                :url="apiUploadUrl"
                field="file"
                langType="en"
                :width="300"
                :height="300"
                @crop-upload-success="handleSuccess"
                @crop-upload-fail="handleFailure"
                noCircle
            />
        </div>
        <div
            :class="vertical ? 'col-12' : 'col-6'"
            class="d-flex flex-column justify-content-center"
            v-if="profileStatus && !profileStatus.has_photo"
        >
            <label
                class="btn btn-primary font-weight-bold"
                @click="() => (cropperIsActive = !cropperIsActive)"
            >
                Add your photo
            </label>
        </div>
    </div>
</template>

<script>
import ImageCropper from "./ImageCropper";

export default {
    name: "PhotoUploadWidget",
    props: ["user", "patient", "profileStatus", "vertical"],
    data() {
        return {
            file_: null,
            uploadedImageUrl: "",
            cropperIsActive: false,
        };
    },
    components: {
        ImageCropper,
    },
    created() {
        this.$bus.$on("upload-photo", () => {
            this.cropperIsActive = true;
        });
    },
    computed: {
        apiUploadUrl() {
            if (this.user) {
                return `/api/users/${this.user.id}/profile_photo`;
            }
            if (this.patient) {
                return `/api/patients/${this.patient.id}/profile_photo`;
            }
        },
        imageUrl() {
            if (this.user) {
                return this.uploadedImageUrl || this.user.profile_photo_url;
            }
            if (this.patient) {
                return this.uploadedImageUrl || this.patient.profile_photo_url;
            }
        },
    },
    methods: {
        handleSuccess({ status, image }) {
            this.uploadedImageUrl = image;
            this.$emit("profile-photo-changed", this.imageUrl);
            this.$bus.$emit("profile-photo-changed", this.imageUrl);
        },
        handleFailure(err) {
            console.error(err);
        },
    },
};
</script>

<style scoped></style>
